<script setup lang="ts">
    defineProps<{
        name?: string
        imgSrc?: string | null
        modifiers?: string
    }>()
    const getInitials = (name?: string) => {
        if (!name) {
            return ''
        }
        return name
            .split(' ')
            .slice(0, 2)
            .map((n) => n.charAt(0).toUpperCase())
            .join('')
    }
</script>

<template>
    <VvAvatar
        :img-src="imgSrc ? imgSrc : undefined"
        :modifiers="`rounded ${!imgSrc ? modifiers : 'transparent'}`">
        <template v-if="name && !imgSrc" #default>
            {{ getInitials(name) }}
        </template>
    </VvAvatar>
</template>
